import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import CalendarWeek from "../../../../../Base/Components/Form/CalendarWeek";
import Card from "../../../../../Base/Components/Card/Card";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import { getDatesProduccion } from "../../../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarDevolucionProveedor, ObtDevolucionesProveedor } from "../../../../../API/Suministros/Devoluciones/DevolucionesInternasRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import DevolucionesProveedorListado from "./Listado/DevolucionesProveedorListado";
import ListadoDevolucionesProveedorCRUD from "./DevolucionesProveedorCRUD/ListadoDevolucionesProveedorCRUD";
import IngresosBodegaCrud from "../IngresosBodega/IngresosCRUD/IngresosBodegaCrud";
import CalendarioOperativo from "../../../../../Base/Components/Form/CalendarioOperativo";



const DevolucionesInternasScreen = () => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [listadoDev, setListadoDev] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [ingresoDialog, setIngresoDialog] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [habilitar, setHabilitar] = useState(true);

  
  const confirmarEliminacion = () => {
    setShowConfirmDialog(true);
  };

  const onHideConfirmDialog = () => {
    setShowConfirmDialog(false);
  };

  const onConfirmEliminacion = () => {
    setShowConfirmDialog(false);
    eliminarDevolucion();
  };

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
      return;
    }
    setLoading(true);
    const fechas = getDatesProduccion(dates);
    const det = await ObtDevolucionesProveedor(fechas)
    setListadoDev(det)
    setLoading(false)
  };

  const eliminarDevolucion = async () => {

    if (selectedDetalle.length > 0) {
      const detalles = selectedDetalle.map((select, index) => ({
        IdDevolucion: select.IdDevolucion,
      }));

      const response = await EliminarDevolucionProveedor(detalles);
      if (response[0]?.ESTADO === 1) {
        toastShow(toast, "success", "Eliminado", response[0].MENSAJE);
        getInfo()
      } else {
        toastShow(toast, "error", 'Error al eliminar la devolución');
      }

    } else {
      toastShow( toast, "error", "No se puede eliminar", "Seleccione una devolución.");
    }
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setIngresoDialog(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setIngresoDialog(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };

  useEffect(() => {
    // getInfo();
    setTitlePage(getLabel(baseLang, "devolucionesP", config.language));
  }, []);

  
  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "devolucionesP", config.language)}</h2>
            {/* <CalendarWeek
              date={dates}
              setDate={setDates}
              buscar={getInfo}
              selectionMode="range"
            /> */}

            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button icon="pi pi-refresh" tooltip="Buscar" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />
            <Button
              icon="pi pi-times"
              type="button"
              className="p-button-danger listado__botones"
              onClick={confirmarEliminacion}
              tooltip="Cancelar"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "top",
              }}
              style={{ marginLeft: 1.5 }}
            />

            <ConfirmDialog
              visible={showConfirmDialog}
              onHide={onHideConfirmDialog}
              message="¿Estás seguro de que deseas eliminar?"
              header="Confirmación"
              icon="pi pi-exclamation-triangle"
              acceptLabel="Sí"
              rejectLabel="No"
              accept={onConfirmEliminacion}
              reject={onHideConfirmDialog}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <DevolucionesProveedorListado
              listadoDev={listadoDev}
              getInfo={getInfo}
              selectedDetalle={selectedDetalle}
              setSelectedDetalle={setSelectedDetalle}
              setOrderToShow={setIngresoToShow}
              setOrdenDialog={setIngresoDialog}
              loading={loading}
            ></DevolucionesProveedorListado>
          </div>
        }
      />

      <Dialog
        visible={ingresoDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={ingresoDialog}
          setOrderToShow={setIngresoToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>

      <Dialog
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        style={{ height: "90vh", width: "1600px" }}
      >
        <ListadoDevolucionesProveedorCRUD actualizarScreen={getInfo}  />
      </Dialog>
    </div>
  );
};

export default DevolucionesInternasScreen;

